// Routes
const PRICING = "/pricing";
// Status
const ACTIVE = "active";
const INACTIVE = "inactive";
const ARCHIVED = "archived";
const SUSPENDED = "suspended";

export const ROUTES = {
  PRICING
};

export const ROUTE_STATUS = {
  ACTIVE,
  INACTIVE
};

export const APPLICATION_STATUS = {
  INACTIVE,
  ACTIVE,
  SUSPENDED,
  ARCHIVED
};
